(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  // The store uses implicit consent — the Customer Privacy banner is hidden and
  // tracking consent is granted so analytics/pixels stay active without a prompt.
  function grantTrackingConsent() {
    if (typeof Shopify === 'undefined' || typeof Shopify.loadFeatures !== 'function') return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !Shopify.customerPrivacy || typeof Shopify.customerPrivacy.setTrackingConsent !== 'function') return;
      Shopify.customerPrivacy.setTrackingConsent({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true,
      }, function () {});
    });
  }
  grantTrackingConsent();

  function initTabs(root) {
    qsa('[data-self-tabs]', root).forEach(function (tabs) {
      var buttons = qsa('[role="tab"]', tabs);
      var panels = qsa('[role="tabpanel"]', tabs);
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          buttons.forEach(function (tab) {
            tab.setAttribute('aria-selected', tab === button ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.id !== button.getAttribute('aria-controls');
          });
        });
      });
    });
  }

  function initWishlist(root) {
    var key = 'self:wishlist';
    var saved = readWishlist();

    function readWishlist() {
      var items = [];
      try {
        items = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (error) {
        items = [];
      }

      if (!Array.isArray(items)) return [];

      return items
        .map(function (item) {
          if (typeof item === 'string') return { handle: item };
          if (item && typeof item === 'object' && item.handle) return item;
          return null;
        })
        .filter(Boolean)
        .filter(function (item, index, list) {
          return list.findIndex(function (savedItem) {
            return savedItem.handle === item.handle;
          }) === index;
        });
    }

    function writeWishlist(items) {
      saved = items;
      try {
        localStorage.setItem(key, JSON.stringify(saved));
      } catch (error) {
        return;
      }
      window.dispatchEvent(new CustomEvent('self:wishlist-change', { detail: { items: saved } }));
    }

    function getSavedIndex(handle) {
      return saved.findIndex(function (item) {
        return item.handle === handle;
      });
    }

    function getButtonProduct(button) {
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return null;

      return {
        handle: handle,
        title: button.getAttribute('data-product-title') || handle,
        url: button.getAttribute('data-product-url') || '/products/' + handle,
        image: button.getAttribute('data-product-image') || '',
        price: button.getAttribute('data-product-price') || '',
        vendor: button.getAttribute('data-product-vendor') || '',
      };
    }

    function updateButton(button) {
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      var isActive = getSavedIndex(handle) >= 0;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        (isActive ? 'Remove ' : 'Add ') + (button.getAttribute('data-product-title') || 'product') + (isActive ? ' from wishlist' : ' to wishlist')
      );
    }

    function updateWishlistButtons() {
      qsa('[data-self-wishlist]').forEach(updateButton);
    }

    function updateWishlistCounts() {
      qsa('[data-self-wishlist-count]').forEach(function (badge) {
        var count = saved.length;
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      });
    }

    function moneyFromProduct(product) {
      if (!product || typeof product.price !== 'number') return '';
      return '$' + (product.price / 100).toFixed(2);
    }

    function hydrateWishlistItem(item) {
      if (item.title && item.image && item.price) return Promise.resolve(item);
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product');
          return response.json();
        })
        .then(function (product) {
          return {
            handle: item.handle,
            title: item.title || product.title || item.handle,
            url: item.url || product.url || '/products/' + item.handle,
            image: item.image || (product.featured_image || ''),
            price: item.price || moneyFromProduct(product),
            vendor: item.vendor || product.vendor || '',
          };
        })
        .catch(function () {
          return {
            handle: item.handle,
            title: item.title || item.handle.replace(/-/g, ' '),
            url: item.url || '/products/' + item.handle,
            image: item.image || '',
            price: item.price || '',
            vendor: item.vendor || '',
          };
        });
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        }[character];
      });
    }

    function renderWishlistPage() {
      var container = qs('[data-self-wishlist-page]');
      if (!container) return;

      var grid = qs('[data-self-wishlist-grid]', container);
      var empty = qs('[data-self-wishlist-empty]', container);
      var count = qs('[data-self-wishlist-page-count]', container);
      if (!grid || !empty) return;

      if (count) count.textContent = saved.length + (saved.length === 1 ? ' item' : ' items');
      empty.hidden = saved.length > 0;
      grid.hidden = saved.length === 0;
      grid.innerHTML = '';

      if (saved.length === 0) return;

      Promise.all(saved.map(hydrateWishlistItem)).then(function (items) {
        saved = items;
        try {
          localStorage.setItem(key, JSON.stringify(saved));
        } catch (error) {}

        grid.innerHTML = items
          .map(function (item) {
            return [
              '<article class="self-wishlist-page__card" data-wishlist-card="' + escapeHtml(item.handle) + '">',
              '<a class="self-wishlist-page__media" href="' + escapeHtml(item.url) + '">',
              item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '',
              '</a>',
              '<div class="self-wishlist-page__info">',
              item.vendor ? '<p class="self-wishlist-page__vendor">' + escapeHtml(item.vendor) + '</p>' : '',
              '<a class="self-wishlist-page__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>',
              item.price ? '<p class="self-wishlist-page__price">' + escapeHtml(item.price) + '</p>' : '',
              '<div class="self-wishlist-page__actions">',
              '<a class="self-wishlist-page__shop" href="' + escapeHtml(item.url) + '">View Product</a>',
              '<button class="self-wishlist-page__remove" type="button" data-self-wishlist-remove data-product-handle="' + escapeHtml(item.handle) + '">Remove</button>',
              '</div>',
              '</div>',
              '</article>',
            ].join('');
          })
          .join('');
      });
    }

    function refreshWishlist() {
      updateWishlistButtons();
      updateWishlistCounts();
      renderWishlistPage();
    }

    qsa('[data-self-wishlist]', root).forEach(function (button) {
      if (button.getAttribute('data-self-wishlist-ready') === 'true') return;
      button.setAttribute('data-self-wishlist-ready', 'true');
      updateButton(button);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var product = getButtonProduct(button);
        if (!product) return;
        var index = getSavedIndex(product.handle);
        if (index >= 0) {
          saved.splice(index, 1);
        } else {
          saved.push(product);
        }
        writeWishlist(saved);
        refreshWishlist();
      });
    });

    window.selfWishlist = window.selfWishlist || {};

    if (!window.selfWishlist.removeReady) {
      window.selfWishlist.removeReady = true;
      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-self-wishlist-remove]');
        if (!button) return;
        event.preventDefault();
        var handle = button.getAttribute('data-product-handle');
        if (!handle) return;
        saved = readWishlist();
        writeWishlist(saved.filter(function (item) {
          return item.handle !== handle;
        }));
        refreshWishlist();
      });
    }

    if (!window.selfWishlist.changeReady) {
      window.selfWishlist.changeReady = true;
      window.addEventListener('self:wishlist-change', function () {
        saved = readWishlist();
        refreshWishlist();
      });
    }

    refreshWishlist();
  }

  function initCartBadge() {
    if (window.selfCartBadge && window.selfCartBadge.ready) {
      window.selfCartBadge.refresh();
      return;
    }

    function getCartUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root + 'cart.js';
      }
      if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) {
        return window.Theme.routes.cart_url + '.js';
      }
      return '/cart.js';
    }

    function isCartEndpoint(url) {
      var value = String(url || '');
      return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(value);
    }

    function getCountFromCartPayload(payload) {
      if (!payload || typeof payload !== 'object') return null;
      if (typeof payload.item_count === 'number') return payload.item_count;
      if (Array.isArray(payload.items)) {
        return payload.items.reduce(function (total, item) {
          return total + (Number(item && item.quantity) || 0);
        }, 0);
      }
      if (payload.detail && typeof payload.detail.itemCount === 'number') return payload.detail.itemCount;
      if (payload.cart && typeof payload.cart.item_count === 'number') return payload.cart.item_count;
      return null;
    }

    function updateCartBadge(count) {
      count = Math.max(0, Number(count) || 0);
      qsa('[data-self-cart-link]').forEach(function (link) {
        var bubble = qs('.cart-bubble', link);
        var countText = qs('.cart-bubble__text-count', link);
        if (!bubble || !countText) return;

        bubble.classList.toggle('visually-hidden', count === 0);
        bubble.toggleAttribute('data-maintain-ratio', count <= 99);
        countText.classList.toggle('hidden', count === 0);
        countText.textContent = count > 99 ? '99+' : String(count);
        link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
      });
    }

    function refreshCartBadge() {
      return fetch(getCartUrl(), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          var count = getCountFromCartPayload(cart);
          if (count !== null) updateCartBadge(count);
        })
        .catch(function () {});
    }

    function refreshFromEvent(event) {
      var count = getCountFromCartPayload(event && event.detail);
      if (count !== null) {
        updateCartBadge(count);
        return;
      }

      if (event && event.promise && typeof event.promise.then === 'function') {
        event.promise
          .then(function (result) {
            var promisedCount = getCountFromCartPayload(result);
            if (promisedCount === null) promisedCount = getCountFromCartPayload(result && result.detail);
            if (promisedCount !== null) updateCartBadge(promisedCount);
            else refreshCartBadge();
          })
          .catch(refreshCartBadge);
        return;
      }

      window.setTimeout(refreshCartBadge, 150);
    }

    window.selfCartBadge = {
      ready: true,
      refresh: refreshCartBadge,
      update: updateCartBadge,
    };

    ['shopify:cart:lines-update', 'cart:refresh', 'cart:updated', 'cart:change'].forEach(function (eventName) {
      document.addEventListener(eventName, refreshFromEvent);
      window.addEventListener(eventName, refreshFromEvent);
    });

    // Auto-open the cart drawer on any add. The drawer component's own check
    // misses adds made on pages that rendered with an empty cart (the stale
    // .cart-drawer--empty class suppresses its open until sections morph).
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!event || event.action !== 'add') return;
      if (event.target instanceof Element && event.target.closest('dialog:modal')) return;
      var pending = event.promise && typeof event.promise.then === 'function' ? event.promise : Promise.resolve();
      pending.then(function (result) {
        var detail = result && result.detail;
        if (detail && detail.didError) return;
        var component = document.querySelector('cart-drawer-component');
        if (!component) return;
        var drawer = component.closest('theme-drawer');
        var inner = component.querySelector('.cart-drawer__inner');
        if (inner) inner.classList.remove('cart-drawer--empty');
        if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
      });
    });

    if (!window.selfCartBadge.fetchPatched && window.fetch) {
      var originalFetch = window.fetch;
      window.selfCartBadge.fetchPatched = true;
      window.fetch = function () {
        var requestUrl = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
        return originalFetch.apply(this, arguments).then(function (response) {
          if (isCartEndpoint(requestUrl)) {
            window.setTimeout(refreshCartBadge, 150);
          }
          return response;
        });
      };
    }

    refreshCartBadge();
  }

  function initCartDrawerLink() {
    if (window.selfCartDrawerLinkReady) return;
    window.selfCartDrawerLinkReady = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-self-cart-link]');
      if (!link) return;
      var drawer = document.getElementById('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      if (typeof drawer.toggle === 'function') {
        drawer.toggle();
      } else {
        drawer.open();
      }
    });
  }

  function initGeoCurrency() {
    if (window.selfGeoCurrencyReady) return;
    window.selfGeoCurrencyReady = true;

    var SUPPORTED = { US: 'US', GB: 'GB' };

    try {
      var current = window.Shopify && window.Shopify.country;
      if (!current || !SUPPORTED[current]) return;
      if (sessionStorage.getItem('self:geo-checked')) return;
      sessionStorage.setItem('self:geo-checked', '1');

      fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          if (!data || !data.detected_values || !data.detected_values.country) return;
          var detected = data.detected_values.country.handle;
          if (!SUPPORTED[detected] || detected === current) return;

          var form = document.createElement('form');
          form.method = 'POST';
          form.action = '/localization';
          form.acceptCharset = 'UTF-8';

          var formType = document.createElement('input');
          formType.type = 'hidden';
          formType.name = 'form_type';
          formType.value = 'localization';
          form.appendChild(formType);

          var country = document.createElement('input');
          country.type = 'hidden';
          country.name = 'country_code';
          country.value = detected;
          form.appendChild(country);

          var back = document.createElement('input');
          back.type = 'hidden';
          back.name = '_method';
          back.value = 'put';
          form.appendChild(back);

          var redirect = document.createElement('input');
          redirect.type = 'hidden';
          redirect.name = 'return_to';
          redirect.value = window.location.pathname + window.location.search;
          form.appendChild(redirect);

          document.body.appendChild(form);
          form.submit();
        })
        .catch(function () {});
    } catch (error) {
      // geo detection is best-effort
    }
  }

  function initChatFab() {
    if (window.selfChatFabReady) return;
    window.selfChatFabReady = true;

    document.addEventListener('click', function (event) {
      var fab = event.target.closest('[data-self-chat-open]');
      if (!fab) return;
      var chat = document.querySelector('shopify-chat');
      var inboxLoaded = !!(window.customElements && (customElements.get('shopify-chat') || (chat && chat.shadowRoot)));
      var drawer = document.getElementById('chat-drawer');
      if (inboxLoaded && chat && typeof chat.show === 'function') {
        chat.setAttribute('mode', 'managed');
        chat.show();
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open();
        return;
      }
      window.location.href = '/contact';
    });

    document.addEventListener('shopify-chat:close', function () {
      var drawer = document.getElementById('chat-drawer');
      if (drawer && drawer.hasAttribute('open') && typeof drawer.close === 'function') drawer.close();
    });
  }

  function initFilters(root) {
    var lastFocusedToggle = null;
    var drawerQuery = window.matchMedia('(max-width: 1199px)');

    function isDrawerMode() {
      return drawerQuery.matches;
    }

    function getLayout(target) {
      return target ? target.closest('.self-collection__layout') : null;
    }

    function getToolbar(target) {
      var layout = getLayout(target);
      if (!layout) return null;
      var previous = layout.previousElementSibling;
      while (previous && !previous.classList.contains('self-collection__toolbar')) {
        previous = previous.previousElementSibling;
      }
      return previous;
    }

    function buildFilterLabel(button, mode) {
      var label = button.getAttribute(mode === 'show' ? 'data-filter-show-label' : 'data-filter-hide-label') || '';
      var count = Number(button.getAttribute('data-filter-count') || '0');
      return label + (count > 0 ? ' (' + count + ')' : '');
    }

    function updateToggleLabel(button, mode) {
      var text = qs('[data-self-filter-toggle-text]', button);
      if (text) {
        text.textContent = buildFilterLabel(button, mode);
      } else {
        button.childNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = buildFilterLabel(button, mode);
        });
      }
    }

    function updateToggles(target, mode, expanded) {
      qsa('[data-self-filter-toggle="#' + target.id + '"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        updateToggleLabel(toggle, mode);
      });
    }

    function setDesktopFiltersHidden(target, isHidden) {
      var layout = getLayout(target);
      var toolbar = getToolbar(target);
      if (layout) layout.classList.toggle('self-collection__layout--filters-hidden', isHidden);
      if (toolbar) toolbar.classList.toggle('is-filters-hidden', isHidden);
      target.classList.remove('is-open');
      target.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
      qsa('[data-self-filter-close="#' + target.id + '"]').forEach(function (control) {
        if (control.classList.contains('self-filter-backdrop')) control.classList.remove('is-open');
      });
      document.documentElement.classList.remove('self-filter-lock');
      updateToggles(target, isHidden ? 'show' : 'hide', !isHidden);
    }

    function setFilterOpen(target, isOpen) {
      if (!target) return;
      if (!isDrawerMode()) {
        setDesktopFiltersHidden(target, isOpen);
        return;
      }
      target.classList.toggle('is-open', isOpen);
      target.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      updateToggles(target, 'show', isOpen);
      qsa('[data-self-filter-close="#' + target.id + '"]').forEach(function (control) {
        if (control.classList.contains('self-filter-backdrop')) {
          control.classList.toggle('is-open', isOpen);
        }
      });
      document.documentElement.classList.toggle('self-filter-lock', isOpen);
      if (isOpen) {
        window.setTimeout(function () {
          target.focus({ preventScroll: true });
        }, 20);
      } else if (lastFocusedToggle) {
        lastFocusedToggle.focus({ preventScroll: true });
      }
    }

    function syncFilterState() {
      qsa('.self-filters', root).forEach(function (target) {
        if (isDrawerMode()) {
          var layout = getLayout(target);
          var toolbar = getToolbar(target);
          if (layout) layout.classList.remove('self-collection__layout--filters-hidden');
          if (toolbar) toolbar.classList.remove('is-filters-hidden');
          target.setAttribute('aria-hidden', target.classList.contains('is-open') ? 'false' : 'true');
          updateToggles(target, 'show', target.classList.contains('is-open'));
        } else {
          var isHidden = getLayout(target) && getLayout(target).classList.contains('self-collection__layout--filters-hidden');
          setDesktopFiltersHidden(target, Boolean(isHidden));
        }
      });
    }

    qsa('[data-self-filter-toggle]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var target = qs(button.getAttribute('data-self-filter-toggle'));
        if (!target) return;
        lastFocusedToggle = button;
        if (isDrawerMode()) {
          setFilterOpen(target, !target.classList.contains('is-open'));
          return;
        }
        var layout = getLayout(target);
        setFilterOpen(target, !(layout && layout.classList.contains('self-collection__layout--filters-hidden')));
      });
    });

    qsa('[data-self-filter-close]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var target = qs(button.getAttribute('data-self-filter-close'));
        if (!target) return;
        setFilterOpen(target, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      qsa('.self-filters.is-open', root).forEach(function (target) {
        setFilterOpen(target, false);
      });
    });

    syncFilterState();
    if (drawerQuery.addEventListener) {
      drawerQuery.addEventListener('change', syncFilterState);
    } else if (drawerQuery.addListener) {
      drawerQuery.addListener(syncFilterState);
    }
  }

  function initManualCollectionFilters(root) {
    qsa('[data-self-collection-layout]', root).forEach(function (layout) {
      var section = layout.closest('.self-collection');
      var form = qs('.self-filter-form', layout);
      var grid = qs('[data-self-product-grid]', layout);
      var activeFilters = section ? qs('[data-self-manual-active-filters]', section) : null;
      var emptyState = qs('[data-self-manual-empty]', layout);
      var filterInputs = qsa('[data-self-manual-filter]', layout);
      var sortInputs = qsa('[data-self-sort-radio]', layout);
      if (!section || !form || !grid) return;

      function normalize(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/&/g, ' and ')
          .replace(/\+/g, ' plus ')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function normalizeFilterValue(value, group) {
        var token = normalize(value);
        if (group === 'color' && token.indexOf('color-') === 0) return token.replace(/^color-/, '');
        return token;
      }

      function normalizeFilterGroup(group) {
        var token = normalize(group);
        if (token === 'style' || token === 'title-style') return 'type';
        if (token === 'colors' || token === 'colour' || token === 'colours') return 'color';
        if (token === 'control-area' || token === 'control-areas') return 'control';
        return token;
      }

      function splitTokens(value) {
        return String(value || '')
          .split(/\s+/)
          .map(normalize)
          .filter(Boolean);
      }

      function normalizeCupToken(value) {
        var token = normalize(value);
        return token === 'ddd' || token === 'f' ? 'ddd-f' : token;
      }

      function normalizeSizeToken(value) {
        var token = normalize(value);
        var aliases = {
          xxl: '2xl',
          xxxl: '3xl',
          xxxxl: '4xl',
          xxxxxl: '5xl'
        };
        return aliases[token] || token;
      }

      function expandGroupedSizeTokens(tokens) {
        return tokens.reduce(function (expanded, token) {
          var normalized = normalizeSizeToken(token);
          if (expanded.indexOf(normalized) === -1) expanded.push(normalized);
          token.split('-').forEach(function (part) {
            var alias = normalizeSizeToken(part);
            if (alias && expanded.indexOf(alias) === -1) expanded.push(alias);
          });
          return expanded;
        }, []);
      }

      function getCardTokens(card, group) {
        if (!card) return [];
        group = normalizeFilterGroup(group);
        if (group === 'color') return splitTokens(card.getAttribute('data-self-product-colors'));
        if (group.indexOf('size') > -1 || group.indexOf('band') > -1 || group.indexOf('cup') > -1) {
          var sizeTokens = splitTokens(card.getAttribute('data-self-product-sizes'));
          if (group.indexOf('band') > -1) {
            var bandTokens = splitTokens(card.getAttribute('data-self-product-bands'));
            if (bandTokens.length) return bandTokens;
            return sizeTokens.map(function (token) {
              var bandMatch = token.match(/^(\d+)/);
              return bandMatch ? bandMatch[1] : '';
            }).filter(Boolean);
          }
          if (group.indexOf('cup') > -1) {
            var cupTokens = splitTokens(card.getAttribute('data-self-product-cups'));
            if (cupTokens.length) return cupTokens.map(normalizeCupToken);
            return sizeTokens.map(function (token) {
              var cupMatch = token.match(/^\d+-?(.+)$/);
              return cupMatch ? normalizeCupToken(cupMatch[1]) : '';
            }).filter(Boolean);
          }
          return expandGroupedSizeTokens(sizeTokens);
        }
        if (group === 'type') {
          return splitTokens(card.getAttribute('data-self-product-type'));
        }
        if (group === 'support') return splitTokens(card.getAttribute('data-self-product-support'));
        if (group === 'control') {
          return splitTokens(card.getAttribute('data-self-product-control'));
        }

        return splitTokens(
          [
            card.getAttribute('data-self-product-tags'),
            card.getAttribute('data-self-product-sizes'),
            card.getAttribute('data-self-product-colors'),
            card.getAttribute('data-self-product-type'),
            card.getAttribute('data-self-product-support'),
            card.getAttribute('data-self-product-control')
          ].join(' ')
        );
      }

      function tokenMatches(token, value, group) {
        if (group.indexOf('size') > -1 && group.indexOf('cup') === -1 && group.indexOf('band') === -1) {
          return normalizeSizeToken(token) === normalizeSizeToken(value);
        }
        if (group === 'color') {
          return token === value || token.indexOf(value + '-') === 0 || token.slice(-(value.length + 1)) === '-' + value;
        }
        if (group === 'type') {
          return token === value || token.indexOf(value) > -1;
        }
        return token === value;
      }

      function matchesCard(card, selected) {
        var groups = selected.reduce(function (result, filter) {
          if (!result[filter.group]) result[filter.group] = [];
          result[filter.group].push(filter);
          return result;
        }, {});

        return Object.keys(groups).every(function (group) {
          var tokens = getCardTokens(card, group);
          return groups[group].some(function (filter) {
            var value = normalizeFilterValue(filter.value, group);
            return tokens.some(function (token) {
              return tokenMatches(token, value, group);
            });
          });
        });
      }

      function setInputLabelState(input) {
        var label = input.closest('label');
        if (label) label.classList.toggle('is-active', input.checked);
      }

      function selectedFilters() {
        return filterInputs
          .filter(function (input) { return input.checked; })
          .map(function (input) {
            return {
              value: input.value,
              label: input.getAttribute('data-self-filter-label') || input.value,
              group: normalizeFilterGroup(input.getAttribute('data-self-filter-group') || ''),
              hidden: input.getAttribute('data-self-filter-hidden') === 'true'
            };
          });
      }

      function selectedSort() {
        var checked = sortInputs.find(function (input) { return input.checked; });
        return checked ? checked.value : '';
      }

      function selectedColor() {
        var checked = filterInputs.find(function (input) {
          return input.checked && normalizeFilterGroup(input.getAttribute('data-self-filter-group') || '') === 'color';
        });
        return checked ? normalizeFilterValue(checked.value, 'color') : '';
      }

      function syncAvailableOptions() {
        var cards = qsa('[data-self-product-card]', grid);
        filterInputs.forEach(function (input) {
          var group = normalizeFilterGroup(input.getAttribute('data-self-filter-group') || '');
          if (!group) return;
          var value = normalizeFilterValue(input.value, group);
          var isAvailable = cards.some(function (card) {
            return getCardTokens(card, group).some(function (token) {
              return tokenMatches(token, value, group);
            });
          });
          var option = input.closest('label');
          if (option) option.hidden = !isAvailable;
          if (!isAvailable) input.checked = false;
        });
      }

      function hydrateAdditionalPages() {
        var pagination = qs('.self-pagination', layout);
        if (!pagination) return Promise.resolve();

        var currentPage = Number(new URL(window.location.href).searchParams.get('page') || '1');
        var pages = qsa('a[href*="page="]', pagination).map(function (link) {
          return Number(new URL(link.href, window.location.href).searchParams.get('page') || '1');
        });
        pages.push(currentPage);
        var lastPage = Math.max.apply(Math, pages);
        if (!Number.isFinite(lastPage) || lastPage <= 1) return Promise.resolve();

        var requests = [];
        for (var pageNumber = 1; pageNumber <= lastPage; pageNumber += 1) {
          if (pageNumber === currentPage) continue;
          var pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('page', String(pageNumber));
          requests.push(
            fetch(pageUrl.toString(), { credentials: 'same-origin' })
              .then(function (response) { return response.ok ? response.text() : ''; })
              .then(function (html) { return html ? new DOMParser().parseFromString(html, 'text/html') : null; })
          );
        }

        return Promise.all(requests).then(function (documents) {
          var handles = new Set(qsa('[data-self-product-card]', grid).map(function (card) {
            return card.getAttribute('data-self-product-handle') || '';
          }));
          var fragment = document.createDocumentFragment();

          documents.forEach(function (pageDocument) {
            if (!pageDocument) return;
            qsa('[data-self-product-card]', pageDocument).forEach(function (card) {
              var handle = card.getAttribute('data-self-product-handle') || '';
              if (!handle || handles.has(handle)) return;
              handles.add(handle);
              fragment.appendChild(document.importNode(card, true));
            });
          });

          initCardSwatches(fragment);
          initProductCardTouch(fragment);
          initQuickAdd(fragment);
          grid.appendChild(fragment);
          pagination.remove();
        });
      }

      function syncVisibleCardSwatches(color) {
        if (!color) return;
        qsa('[data-self-product-card]', grid).forEach(function (card) {
          if (card.hidden) return;
          var swatch = qsa('[data-self-card-swatch], [data-card-swatch]', card).find(function (button) {
            return tokenMatches(normalize(button.getAttribute('data-swatch-value')), color, 'color');
          });
          if (swatch) swatch.click();
        });
      }

      function sortCards() {
        var sortValue = selectedSort();
        var cards = qsa('[data-self-product-card]', grid);
        if (!sortValue || cards.length < 2) return;

        cards
          .sort(function (a, b) {
            if (sortValue === 'price-ascending' || sortValue === 'price-descending') {
              var priceA = Number(a.getAttribute('data-self-product-price') || 0);
              var priceB = Number(b.getAttribute('data-self-product-price') || 0);
              return sortValue === 'price-ascending' ? priceA - priceB : priceB - priceA;
            }
            if (sortValue === 'created-descending') {
              var createdA = Number(a.getAttribute('data-self-product-created') || 0);
              var createdB = Number(b.getAttribute('data-self-product-created') || 0);
              return createdB - createdA;
            }
            return 0;
          })
          .forEach(function (card) {
            grid.appendChild(card);
          });
      }

      function renderActiveFilters(selected) {
        if (!activeFilters) return;
        var visibleSelected = selected.filter(function (filter) { return !filter.hidden; });
        activeFilters.innerHTML = '';
        if (!visibleSelected.length) {
          activeFilters.hidden = true;
          return;
        }

        visibleSelected.forEach(function (filter) {
          var button = document.createElement('button');
          button.className = 'self-active-filter';
          button.type = 'button';
          button.setAttribute('data-self-manual-chip', filter.value);
          button.innerHTML = '<span>' + filter.label + '</span><span aria-hidden="true">×</span>';
          activeFilters.appendChild(button);
        });
        activeFilters.hidden = false;
      }

      function applyFilters() {
        var selected = selectedFilters();
        var color = selectedColor();
        var visibleCount = 0;

        sortCards();
        filterInputs.forEach(setInputLabelState);
        qsa('[data-self-product-card]', grid).forEach(function (card) {
          var isVisible = !selected.length || matchesCard(card, selected);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        section.setAttribute('data-self-manual-filtering-active', selected.length ? 'true' : 'false');
        renderActiveFilters(selected);
        syncVisibleCardSwatches(color);
        if (emptyState) emptyState.hidden = !selected.length || visibleCount > 0;
      }

      filterInputs.forEach(function (input) {
        setInputLabelState(input);
        input.addEventListener('change', applyFilters);
      });

      sortInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (filterInputs.some(function (manualInput) { return manualInput.checked; })) {
            applyFilters();
          }
        });
      });

      form.addEventListener('submit', function (event) {
        if (filterInputs.some(function (input) { return input.checked; })) {
          event.preventDefault();
          applyFilters();
        }
      });

      if (activeFilters) {
        activeFilters.addEventListener('click', function (event) {
          var chip = event.target.closest('[data-self-manual-chip]');
          if (!chip) return;
          var value = chip.getAttribute('data-self-manual-chip');
          filterInputs.forEach(function (input) {
            if (input.value === value) input.checked = false;
          });
          applyFilters();
        });
      }

      applyFilters();
      hydrateAdditionalPages()
        .then(function () {
          syncAvailableOptions();
          applyFilters();
          window.setTimeout(applyFilters, 100);
          window.setTimeout(applyFilters, 500);
        })
        .catch(function () {
          syncAvailableOptions();
          applyFilters();
          window.setTimeout(applyFilters, 100);
        });
    });
  }

  function getCartSectionIds() {
    return qsa('cart-items-component')
      .map(function (item) {
        return item instanceof HTMLElement ? item.dataset.sectionId : '';
      })
      .filter(Boolean);
  }

  function fetchCartState() {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function dispatchCartLinesUpdate(root, data) {
    var event = new Event('shopify:cart:lines-update', { bubbles: true });
    event.action = 'add';
    event.context = 'product-card';
    event.lines = [{ merchandiseId: String(data.variantId), quantity: data.quantity }];
    event.promise = fetchCartState().then(function (cart) {
      return {
        cart: cart,
        detail: {
          sections: data.sections,
          itemCount: Number(cart && cart.item_count) || data.quantity,
          source: 'self-product-card',
          didError: false
        }
      };
    });
    root.dispatchEvent(event);
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    var number = Number(value);
    if (!Number.isFinite(number) || number < 0) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(number);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    }).format(number / 100);
  }

  function ensureQuickViewModal() {
    var existing = qs('[data-self-quick-view-modal]');
    if (existing) return existing;

    if (!qs('#self-quick-view-modal-styles')) {
      var style = document.createElement('style');
      style.id = 'self-quick-view-modal-styles';
      style.textContent = [
        '.self-quick-view{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:24px;margin:0;border:0;width:auto;max-width:none;height:auto;max-height:none;background:rgba(10,10,10,.42);}',
        '.self-quick-view::backdrop{background:transparent;}',
        '.self-quick-view.is-open{display:flex;}',
        '.self-quick-view__dialog{position:relative;width:min(760px,calc(100vw - 32px));max-height:calc(100vh - 48px);overflow:auto;border-radius:20px;background:#fff;box-shadow:0 24px 72px rgba(0,0,0,.22);}',
        '.self-quick-view__body{display:grid;grid-template-columns:minmax(220px,300px) 1fr;gap:28px;padding:24px;}',
        '.self-quick-view__media{overflow:hidden;border-radius:16px;background:#f3f4f6;aspect-ratio:1/1;}',
        '.self-quick-view__media img{display:block;width:100%;height:100%;object-fit:cover;}',
        '.self-quick-view__content{display:flex;flex-direction:column;justify-content:center;gap:14px;}',
        '.self-quick-view__eyebrow{margin:0;font-family:"Inter Tight",sans-serif;font-size:12px;font-weight:500;line-height:16.8px;color:#5c5c5c;text-transform:uppercase;}',
        '.self-quick-view__title{margin:0;font-family:"Helvetica Neue",Arial,sans-serif;font-size:28px;font-weight:700;line-height:33.6px;color:#0a0a0a;}',
        '.self-quick-view__price{display:flex;align-items:baseline;gap:8px;margin:0;font-family:"Helvetica Neue",Arial,sans-serif;font-size:24px;font-weight:700;line-height:28.8px;color:#0a0a0a;}',
        '.self-quick-view__compare{font-family:"Inter Tight",sans-serif;font-size:14px;font-weight:400;line-height:19.6px;color:#7a7a7a;text-decoration:line-through;}',
        '.self-quick-view__description{margin:0;font-family:"Inter Tight",sans-serif;font-size:16px;font-weight:400;line-height:22.4px;color:#55504b;}',
        '.self-quick-view__actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:4px;}',
        '.self-quick-view__link{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:14px 28px;border-radius:999px;background:#181818;color:#fff;font-family:"Inter Tight",sans-serif;font-size:16px;font-weight:700;line-height:16px;text-transform:uppercase;text-decoration:none;}',
        '.self-quick-view__close{position:absolute;top:12px;right:12px;width:40px;height:40px;border:0;border-radius:50%;background:#f7f7f6;color:#181818;font-size:26px;line-height:1;cursor:pointer;}',
        '@media (max-width: 640px){.self-quick-view{padding:16px;align-items:flex-end;}.self-quick-view__dialog{width:100%;max-height:calc(100vh - 32px);border-radius:18px;}.self-quick-view__body{grid-template-columns:1fr;gap:18px;padding:18px;}.self-quick-view__media{aspect-ratio:4/3;}.self-quick-view__title{font-size:24px;line-height:28.8px;}}'
      ].join('');
      document.head.appendChild(style);
    }

    var modal = document.createElement('dialog');
    modal.className = 'self-quick-view';
    modal.setAttribute('data-self-quick-view-modal', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="self-quick-view__dialog" role="document">',
      '<button class="self-quick-view__close" type="button" data-self-quick-view-close aria-label="Close quick view">&times;</button>',
      '<div class="self-quick-view__body">',
      '<div class="self-quick-view__media" data-self-quick-view-media></div>',
      '<div class="self-quick-view__content">',
      '<p class="self-quick-view__eyebrow" data-self-quick-view-vendor></p>',
      '<h2 class="self-quick-view__title" data-self-quick-view-title></h2>',
      '<p class="self-quick-view__price"><span data-self-quick-view-price></span><span class="self-quick-view__compare" data-self-quick-view-compare></span></p>',
      '<p class="self-quick-view__description" data-self-quick-view-description></p>',
      '<div class="self-quick-view__actions"><a class="self-quick-view__link" data-self-quick-view-link href="#">View Product</a></div>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-self-quick-view-close]')) {
        closeQuickViewModal(modal);
      }
    });

    // Keep state/classes in sync when the dialog closes for any reason
    // (our close button, Escape, or a native cancel).
    modal.addEventListener('close', function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('self-quick-view-lock');
      document.dispatchEvent(new CustomEvent('self-qv:close'));
    });

    // Capture-phase so this runs before other document keydown listeners
    // (e.g. the cart drawer's own Escape handler) — stopPropagation keeps the
    // drawer open underneath while the top-layer Quick View closes.
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape' || !modal.open) return;
        event.stopPropagation();
        closeQuickViewModal(modal);
      },
      true
    );

    document.body.appendChild(modal);
    return modal;
  }

  function closeQuickViewModal(modal) {
    if (modal.open && typeof modal.close === 'function') {
      modal.close();
      return;
    }
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('self-quick-view-lock');
  }

  function openQuickView(data) {
    var modal = ensureQuickViewModal();
    var title = data.title || 'Product';
    var image = data.image || '';
    var url = data.url || '#';
    var price = data.price || '';
    var compare = data.compare || '';

    qs('[data-self-quick-view-title]', modal).textContent = title;
    qs('[data-self-quick-view-vendor]', modal).textContent = data.vendor || '';
    qs('[data-self-quick-view-description]', modal).textContent = data.description || '';
    qs('[data-self-quick-view-price]', modal).textContent = price;
    qs('[data-self-quick-view-compare]', modal).textContent = compare;
    qs('[data-self-quick-view-compare]', modal).hidden = !compare;
    qs('[data-self-quick-view-link]', modal).href = url;
    qs('[data-self-quick-view-link]', modal).setAttribute('aria-label', 'View ' + title);
    qs('[data-self-quick-view-media]', modal).innerHTML = image
      ? '<img src="' + image.replace(/"/g, '&quot;') + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="eager">'
      : '';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('self-quick-view-lock');
    if (typeof modal.showModal === 'function' && !modal.open) {
      // Top-layer dialog — renders above the open cart drawer without
      // closing it (z-index alone cannot beat an open <dialog>).
      modal.showModal();
    }
    document.dispatchEvent(new CustomEvent('self-qv:open'));
    var close = qs('[data-self-quick-view-close]', modal);
    if (close) close.focus({ preventScroll: true });
  }

  function openQuickViewFromElement(element) {
    if (!element) return;
    openQuickView({
      title: element.getAttribute('data-product-title') || element.getAttribute('aria-label') || '',
      vendor: element.getAttribute('data-product-vendor') || '',
      description: element.getAttribute('data-product-description') || '',
      url: element.getAttribute('data-product-url') || '#',
      image: element.getAttribute('data-product-image') || '',
      price: element.getAttribute('data-product-price') || formatMoney(element.getAttribute('data-product-price-cents')),
      compare: element.getAttribute('data-product-compare') || formatMoney(element.getAttribute('data-product-compare-cents'))
    });
  }

  function initQuickAdd(root) {
    qsa('[data-self-card-quick-add]', root).forEach(function (trigger) {
      if (trigger.dataset.selfQuickAddReady === 'true') return;
      trigger.dataset.selfQuickAddReady = 'true';

      if (trigger.tagName !== 'FORM') {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          if (trigger.disabled) return;
          openQuickViewFromElement(trigger);
        });
        return;
      }

      var form = trigger;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = qs('button[type="submit"]', form);
        var idInput = qs('input[name="id"]', form);
        var status = qs('.self-product-card__quick-status', form);
        if (!button || !idInput || button.disabled) return;

        var addText = button.getAttribute('data-add-text') || button.textContent;
        if (/quick\s*view/i.test(addText)) {
          openQuickViewFromElement(form);
          return;
        }
        var addingText = button.getAttribute('data-adding-text') || addText;
        var addedText = button.getAttribute('data-added-text') || addText;
        var soldText = button.getAttribute('data-sold-text') || addText;
        var sectionIds = getCartSectionIds();
        var formData = new FormData(form);
        formData.set('quantity', formData.get('quantity') || '1');
        if (sectionIds.length) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = addingText;
        if (status) status.textContent = addingText;

        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (response.ok) return response.json();
            return response.json().catch(function () {
              return {};
            }).then(function (errorJson) {
              throw new Error(errorJson.description || errorJson.message || 'Unable to add item');
            });
          })
          .then(function (responseJson) {
            button.textContent = addedText;
            if (status) status.textContent = addedText;
            dispatchCartLinesUpdate(form, {
              sections: responseJson.sections,
              quantity: Number(formData.get('quantity')) || 1,
              variantId: idInput.value
            });
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function () {
              button.disabled = false;
              button.removeAttribute('aria-busy');
              button.textContent = addText;
              if (status) status.textContent = '';
            }, 1400);
          })
          .catch(function (error) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = idInput.value ? addText : soldText;
            if (status) status.textContent = error.message || 'Unable to add item';
            form.dispatchEvent(new CustomEvent('shopify:cart:error', {
              bubbles: true,
              detail: {
                source: 'self-product-card',
                error: error,
                message: error.message
              }
            }));
          });
      });
    });
  }

  function initExactBestsellers(root) {
    qsa('.self-home-products[data-self-product-tabs]', root).forEach(function (section) {
      if (section.dataset.selfExactBestsellersReady === 'true') return;
      var heading = qs('.self-home-products__heading', section);
      if (!heading || heading.textContent.trim().toLowerCase() !== 'bestsellers') return;
      section.dataset.selfExactBestsellersReady = 'true';

      var map = {
        'Bras': [
          'flex-support-wireless-t-shirt-bra',
          'everyday-wireless-comfort-bra',
          'smooth-lift-underwire-t-shirt-bra',
          'full-coverage-wide-strap-underwire-bra',
          'barelift-wireless-shaping-bra',
          'convertible-strapless-longline-underwire-bra',
          'wide-band-full-coverage-underwire-bra',
          'soft-support-wireless-bra',
          'staylift-strapless-bra'
        ],
        'Tanks & Camis': [
          'all-day-scoop-neck-cami-top',
          'all-day-support-tank-top',
          'everyday-shaping-cami',
          'sculpt-support-tank'
        ],
        'Underwear': [
          'everyday-mid-waist-brief-panty',
          'everyday-shaping-underwear-thong',
          'high-waist-shaper-shorts',
          'smooth-high-waist-brief',
          'high-waisted-sculpting-brief',
          'lift-mid-thigh-shaper-shorts'
        ],
        'Bodysuits': [
          'seamless-long-sleeve-shaping-brief-bodysuit',
          'scoop-neck-short-sleeve-shaping-bodysuit',
          'full-length-sculpt-support-bodysuit',
          'button-front-long-sleeve-thong-bodysuit',
          'strapless-mid-thigh-shaper-bodysuit',
          'sculptlift-underwire-thong-bodysuit',
          'front-zip-butt-lift-shaper-bodysuit',
          'zip-up-full-bust-mid-thigh-shaper-bodysuit',
          'cupped-sculpting-thong-bodysuit',
          'sheer-mesh-thong-bodysuit',
          'deep-v-waist-smoothing-catsuit'
        ]
      };

      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
        });
      }

      function imageUrl(src, width) {
        if (!src) return '';
        return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (width || 1200);
      }

      function colorMedia(product, color, frontImage) {
        var colorToken = String(color || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        if (!colorToken) return '';
        var matches = (product.images || []).filter(function (image) {
          return String(image || '').toLowerCase().indexOf(colorToken) !== -1;
        });
        var back = matches.find(function (image) {
          return /(^|[-_])(back|rear)([-_.]|$)/i.test(String(image || ''));
        });
        return imageUrl(back || matches.find(function (image) { return image !== frontImage; }) || '');
      }

      function colorValue(value) {
        var normalized = String(value || '').toLowerCase();
        if (normalized.indexOf('black') >= 0) return '#171717';
        if (normalized.indexOf('white') >= 0) return '#ffffff';
        if (normalized.indexOf('ivory') >= 0) return '#f6efe7';
        if (normalized.indexOf('cream') >= 0) return '#f2e5d8';
        if (normalized.indexOf('beige') >= 0) return '#d5bda6';
        if (normalized.indexOf('tan') >= 0 || normalized.indexOf('sand') >= 0) return '#d8c0af';
        if (normalized.indexOf('nude') >= 0) return '#caa58f';
        if (normalized.indexOf('mocha') >= 0) return '#8b5f4a';
        if (normalized.indexOf('brown') >= 0 || normalized.indexOf('cocoa') >= 0 || normalized.indexOf('coffee') >= 0) return '#6d493b';
        if (normalized.indexOf('red') >= 0) return '#b82d2d';
        if (normalized.indexOf('pink') >= 0 || normalized.indexOf('rose') >= 0) return '#d79a9a';
        if (normalized.indexOf('blue') >= 0) return '#3b82f6';
        if (normalized.indexOf('green') >= 0) return '#22c55e';
        if (normalized.indexOf('yellow') >= 0 || normalized.indexOf('gold') >= 0) return '#f4c20d';
        if (normalized.indexOf('orange') >= 0) return '#f97316';
        if (normalized.indexOf('purple') >= 0 || normalized.indexOf('plum') >= 0) return '#9b51e0';
        if (normalized.indexOf('gray') >= 0 || normalized.indexOf('grey') >= 0) return '#8d8d8d';
        return '#d9c2b5';
      }

      function cardLabel(product) {
        var tags = product.tags || [];
        return tags.find(function (tag) {
          return tag === 'Everyday' || tag === 'EveryDay' || tag === 'ComfortFirst' || tag === 'Tight Support';
        }) || product.type || '';
      }

      function renderCard(product) {
        var variants = product.variants || [];
        var variant = variants.find(function (item) { return item.available; }) || variants[0] || {};
        var productUrl = '/products/' + product.handle;
        var featured = imageUrl(product.featured_image || (product.images || [])[0]);
        var hover = '';
        var price = Number(product.price || variant.price || 0);
        var compare = Number(product.compare_at_price_max || variant.compare_at_price || 0);
        var displayPrice = price;
        var displayCompare = compare > price ? compare : 0;
        var label = cardLabel(product);
        var colorOption = (product.options || []).find(function (option) { return /colou?r/i.test(option.name || ''); });
        var swatches = '';
        if (colorOption && colorOption.values) {
          swatches = colorOption.values.slice(0, 6).map(function (value, index) {
            var swatchVariant = variants.find(function (item) {
              return item.options && item.options[colorOption.position - 1] === value && item.available;
            }) || variants.find(function (item) {
              return item.options && item.options[colorOption.position - 1] === value;
            }) || variant;
            var swatchPrice = Number(swatchVariant.price || displayPrice);
            var swatchCompare = Number(swatchVariant.compare_at_price || 0);
            var swatchImageSource = (swatchVariant.featured_image && swatchVariant.featured_image.src) || featured;
            var swatchImage = imageUrl(swatchImageSource);
            var swatchHoverImage = colorMedia(product, value, swatchImageSource);
            return '<button class="self-swatch' + (index === 0 ? ' self-swatch--selected' : '') + '" type="button" title="' + escapeHtml(value) + '" aria-label="' + escapeHtml(value) + '" aria-pressed="' + (index === 0 ? 'true' : 'false') + '" style="--swatch: ' + colorValue(value) + ';" data-self-card-swatch data-variant-id="' + (swatchVariant.id || '') + '" data-product-url="' + productUrl + (swatchVariant.id ? '?variant=' + swatchVariant.id : '') + '" data-product-image="' + escapeHtml(swatchImage) + '" data-product-hover-image="' + escapeHtml(swatchHoverImage) + '" data-product-price="' + formatMoney(swatchPrice) + '" data-product-compare="' + (swatchCompare > swatchPrice ? formatMoney(swatchCompare) : '') + '"></button>';
          }).join('');
          if (colorOption.values.length > 6) {
            swatches += '<span class="self-swatch self-swatch--more" aria-label="' + (colorOption.values.length - 6) + ' more colors">+' + (colorOption.values.length - 6) + '</span>';
          }
        }

        var quickView = variant.available === false ? '' : '<div class="self-product-card__quick-form"><button class="self-product-card__quick-button" type="button" data-self-card-quick-add data-product-title="' + escapeHtml(product.title) + '" data-product-vendor="' + escapeHtml(label) + '" data-product-url="' + productUrl + '" data-product-image="' + escapeHtml(featured) + '" data-product-price="' + formatMoney(displayPrice) + '" data-product-compare="' + formatMoney(displayCompare) + '" data-add-text="Quick View" aria-label="Quick view ' + escapeHtml(product.title) + '">Quick View</button></div>';

        return '<div class="self-home-products__ordered-card"><article class="self-product-card"><div class="self-product-card__media-shell" style="--card-ratio: 1 / 1;"><a class="self-product-card__media" href="' + productUrl + '" style="--card-ratio: 1 / 1;" aria-label="' + escapeHtml(product.title) + '">' + (featured ? '<img src="' + escapeHtml(featured) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') + (hover ? '<span class="self-product-card__hover" aria-hidden="true"><img src="' + escapeHtml(hover) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></span>' : '') + '<span class="self-product-card__badge-frame" aria-hidden="true"><span class="self-product-card__badge" data-badge-tone="default">BESTSELLERS</span></span></a>' + quickView + '</div><div class="self-product-card__info">' + (label ? '<div class="self-product-card__meta"><span>' + escapeHtml(label) + '</span></div>' : '') + '<a class="self-product-card__title" href="' + productUrl + '">' + escapeHtml(product.title) + '</a>' + (swatches ? '<div class="self-product-card__swatches" aria-label="Available colors">' + swatches + '</div>' : '') + '<div class="self-product-card__price"><span class="price">' + formatMoney(displayPrice) + '</span><span class="compare-at-price">' + formatMoney(displayCompare) + '</span></div></div></article></div>';
      }

      qsa('[data-self-product-tab]', section).forEach(function (tab) {
        var handles = map[tab.textContent.trim()];
        var panel = qs('#' + tab.getAttribute('aria-controls'), section);
        var grid = panel && qs('.self-home-products__grid', panel);
        if (!handles || !grid) return;
        Promise.all(handles.map(function (handle) {
          return fetch('/products/' + handle + '.js').then(function (response) {
            return response.ok ? response.json() : null;
          }).catch(function () { return null; });
        })).then(function (products) {
          grid.innerHTML = products.filter(Boolean).map(renderCard).join('');
          initCardSwatches(grid);
          initQuickAdd(grid);
        });
      });
    });
  }

  function initCardSwatches(root) {
    qsa('[data-self-card-swatch]', root).forEach(function (button) {
      if (button.dataset.selfCardSwatchReady === 'true') return;
      button.dataset.selfCardSwatchReady = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var card = button.closest('.self-product-card');
        if (!card) return;
        var variantId = button.getAttribute('data-variant-id') || '';
        var productUrl = button.getAttribute('data-product-url') || '';
        var productImage = button.getAttribute('data-product-image') || '';
        var productHoverImage = button.getAttribute('data-product-hover-image') || '';
        var productPrice = button.getAttribute('data-product-price') || '';
        var productCompare = button.getAttribute('data-product-compare') || '';

        qsa('[data-self-card-swatch]', card).forEach(function (sibling) {
          var isSelected = sibling === button;
          sibling.classList.toggle('self-swatch--selected', isSelected);
          sibling.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (productUrl) {
          qsa('.self-product-card__media, .self-product-card__title', card).forEach(function (link) {
            if (link && link.tagName === 'A') link.href = productUrl;
          });
        }

        if (productImage) {
          var mainImage = qs('.self-product-card__media > img', card);
          if (mainImage) {
            mainImage.src = productImage;
            mainImage.removeAttribute('srcset');
          }
        }

        var hoverFrame = qs('.self-product-card__hover', card);
        var hoverImage = hoverFrame && qs('img', hoverFrame);
        if (hoverFrame) {
          hoverFrame.hidden = !productHoverImage;
          if (productHoverImage && hoverImage) {
            hoverImage.src = productHoverImage;
            hoverImage.removeAttribute('srcset');
          }
        }

        if (variantId) {
          var quickForm = qs('[data-self-card-quick-add]', card);
          var idInput = quickForm && qs('input[name="id"]', quickForm);
          if (idInput) idInput.value = variantId;
          if (quickForm) {
            if (productUrl) quickForm.setAttribute('data-product-url', productUrl);
            if (productImage) quickForm.setAttribute('data-product-image', productImage);
            if (productPrice) quickForm.setAttribute('data-product-price', productPrice);
            quickForm.setAttribute('data-product-compare', productCompare || '');
          }
        }

        var price = qs('.self-product-card__price .price', card);
        var compare = qs('.self-product-card__price .compare-at-price', card);
        if (price && productPrice) price.textContent = productPrice;
        if (compare) {
          compare.textContent = productCompare || '';
          compare.hidden = !productCompare;
        }
      });
    });
  }

  function initProductCardTouch(root) {
    qsa('.self-product-card__media-shell', root).forEach(function (shell) {
      if (shell.dataset.selfTouchQuickViewReady === 'true') return;
      shell.dataset.selfTouchQuickViewReady = 'true';

      shell.addEventListener('touchstart', function () {
        var card = shell.closest('.self-product-card');
        if (!card) return;
        card.classList.add('is-touch-image-hover');
        card.classList.add('is-touch-active');
        clearTimeout(card.selfTouchQuickViewTimer);
        card.selfTouchQuickViewTimer = setTimeout(function () {
          card.classList.remove('is-touch-active');
        }, 2200);
      }, { passive: true });

      ['touchend', 'touchcancel'].forEach(function (eventName) {
        shell.addEventListener(eventName, function () {
          var card = shell.closest('.self-product-card');
          if (!card) return;
          card.classList.remove('is-touch-image-hover');
        }, { passive: true });
      });
    });
  }

  function initProductGallery(root) {
    qsa('[data-self-gallery]', root).forEach(function (gallery) {
      var stage = qs('[data-self-gallery-stage]', gallery);
      if (!stage) return;
      qsa('[data-self-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-image-src');
          var srcset = thumb.getAttribute('data-image-srcset');
          var alt = thumb.getAttribute('data-image-alt') || '';
          var image = qs('img', stage);
          if (!image || !src) return;
          image.src = src;
          if (srcset) image.srcset = srcset;
          image.alt = alt;
        });
      });
    });
  }

  function setProductGalleryImage(gallery, src, alt) {
    var stage = gallery && qs('[data-self-gallery-stage]', gallery);
    var image = stage && qs('img', stage);
    if (!image || !src) return;
    image.src = src;
    image.removeAttribute('srcset');
    image.alt = alt || image.alt || '';
  }

  function filterProductGalleryByColor(wrap, colorValue, variant) {
    var productSection = wrap.closest('.self-pdp');
    var gallery = productSection && qs('[data-self-gallery]', productSection);
    if (!gallery) return;

    var colorKey = String(colorValue || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    var firstVisibleThumb = null;

    qsa('[data-self-gallery-thumb]', gallery).forEach(function (thumb) {
      var mediaKey = thumb.getAttribute('data-media-key') || '';
      var matches = !colorKey || mediaKey.indexOf(colorKey) >= 0;
      thumb.hidden = !matches;
      if (matches && !firstVisibleThumb) firstVisibleThumb = thumb;
    });

    if (!firstVisibleThumb) {
      qsa('[data-self-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.hidden = false;
      });
    }

    if (variant && variant.image) {
      setProductGalleryImage(gallery, variant.image, variant.imageAlt);
    } else if (firstVisibleThumb) {
      setProductGalleryImage(
        gallery,
        firstVisibleThumb.getAttribute('data-image-src'),
        firstVisibleThumb.getAttribute('data-image-alt')
      );
    }
  }

  function initVariantForms(root) {
    qsa('[data-self-product-form]', root).forEach(function (wrap) {
      var script = qs('[data-self-variants]', wrap);
      var idInput = qs('input[name="id"]', wrap);
      var submit = qs('[data-self-submit]', wrap);
      if (!script || !idInput) return;

      var variants = [];
      try {
        variants = JSON.parse(script.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      if (!variants.length) return;

      var selected = variants[0].options.slice();
      qsa('[data-option-index]', wrap).forEach(function (button) {
        if (button.classList.contains('is-active')) {
          selected[Number(button.getAttribute('data-option-index'))] = button.getAttribute('data-option-value');
        }

        button.addEventListener('click', function () {
          var optionIndex = Number(button.getAttribute('data-option-index'));
          selected[optionIndex] = button.getAttribute('data-option-value');
          qsa('[data-option-index="' + optionIndex + '"]', wrap).forEach(function (sibling) {
            sibling.classList.toggle('is-active', sibling === button);
          });

          var variant = variants.find(function (item) {
            return item.options.every(function (value, index) {
              return value === selected[index];
            });
          });
          if (!variant) return;
          idInput.value = variant.id;
          if (button.classList.contains('self-option-button--swatch')) {
            filterProductGalleryByColor(wrap, button.getAttribute('data-option-value'), variant);
          }
          if (submit) {
            submit.disabled = !variant.available;
            submit.textContent = variant.available ? submit.getAttribute('data-add-text') : submit.getAttribute('data-sold-text');
          }
        });
      });
    });
  }

  function initFinder(root) {
    qsa('[data-self-finder]', root).forEach(function (finder) {
      var form = qs('[data-self-finder-form]', finder);
      var result = qs('[data-self-finder-result]', finder);
      var unit = 'in';

      qsa('[data-self-finder-start]', finder).forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = qs(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });

      qsa('[data-self-unit]', finder).forEach(function (button) {
        button.addEventListener('click', function () {
          unit = button.getAttribute('data-self-unit') || 'in';
          qsa('[data-self-unit]', finder).forEach(function (sibling) {
            var isActive = sibling === button;
            sibling.classList.toggle('is-active', isActive);
            sibling.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          qsa('[data-self-unit-label]', finder).forEach(function (label) {
            label.textContent = unit === 'cm' ? 'cm' : 'in';
          });
        });
      });

      if (!form || !result) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var scale = unit === 'cm' ? 2.54 : 1;
        var bust = Number((qs('[name="bust"]', form) || {}).value || 0) / scale;
        var under = Number((qs('[name="underbust"]', form) || {}).value || 0) / scale;
        var waist = Number((qs('[name="waist"]', form) || {}).value || 0) / scale;
        var hip = Number((qs('[name="hip"]', form) || {}).value || 0) / scale;
        var band = Math.round(under);
        if (band % 2 !== 0) band += 1;

        var diff = Math.max(0, Math.round(bust - band));
        var cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G'];
        var cup = cups[Math.min(diff, cups.length - 1)] || 'C';
        var shape = waist && hip && hip - waist >= 10 ? 'high-waist shaping' : 'smooth everyday shaping';
        var line = bust && under ? 'Estimated bra size: ' + band + cup + '. ' : '';
        line += 'Best starting point: ' + shape + '.';

        qs('[data-self-finder-text]', result).textContent = line;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function initBackToTop(root) {
    qsa('[data-self-back-to-top]', root).forEach(function (button) {
      if (button.dataset.selfBackToTopReady === 'true') return;
      button.dataset.selfBackToTopReady = 'true';

      button.addEventListener('click', function () {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var scrollOptions = {
          top: 0,
          left: 0,
          behavior: reduceMotion ? 'auto' : 'smooth',
        };
        var scrollingElement = document.scrollingElement || document.documentElement;
        var wrapper = qs('.page-wrapper');

        window.scrollTo(scrollOptions);
        if (scrollingElement && typeof scrollingElement.scrollTo === 'function') {
          scrollingElement.scrollTo(scrollOptions);
        }
        if (wrapper && typeof wrapper.scrollTo === 'function') {
          wrapper.scrollTo(scrollOptions);
        }
      });
    });
  }

  function initCollectionSeoToggles(root) {
    qsa('[data-self-collection-seo]', root).forEach(function (section) {
      var toggle = qs('[data-self-collection-seo-toggle]', section);
      if (!toggle || toggle.dataset.selfCollectionSeoReady === 'true') return;
      toggle.dataset.selfCollectionSeoReady = 'true';

      toggle.addEventListener('click', function () {
        var isExpanded = section.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        toggle.textContent = isExpanded
          ? (section.getAttribute('data-read-less-label') || 'Read Less')
          : (section.getAttribute('data-read-more-label') || 'Read More');
      });
    });
  }

  function initPdpZoomCloseSafeguard(root) {
    qsa('[data-pdp-zoom-close]', root).forEach(function (button) {
      if (button.dataset.selfPdpZoomCloseReady === 'true') return;
      button.dataset.selfPdpZoomCloseReady = 'true';

      button.addEventListener(
        'click',
        function (event) {
          var zoom = button.closest('[data-pdp-zoom]');
          if (!zoom) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof zoom.__closeZoom === 'function') {
            zoom.__closeZoom();
            return;
          }
          zoom.classList.remove('is-open');
          zoom.setAttribute('aria-hidden', 'true');
          zoom.style.cssText = '';
          var image = qs('[data-pdp-zoom-image]', zoom);
          if (image) image.removeAttribute('src');
          document.documentElement.style.overflow = '';
          document.body.classList.remove('self-pdp-zoom-open');
          Array.prototype.forEach.call(document.body.children, function (child) {
            if (child !== zoom) {
              child.style.visibility = '';
              child.style.pointerEvents = '';
            }
          });
        },
        true
      );
    });
  }

  function initPdpQuestionAccordions(root) {
    qsa('.self-figma-pdp__qa-item', root).forEach(function (item) {
      if (item.dataset.selfQuestionAccordionReady === 'true') return;
      var question = item.querySelector('.self-figma-pdp__qa-question');
      if (!question) return;
      item.dataset.selfQuestionAccordionReady = 'true';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'self-figma-pdp__qa-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span>' + question.innerHTML + '</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      question.replaceWith(button);
      var answer = item.querySelector('.self-figma-pdp__description-copy, .self-figma-pdp__qa-answer, p');
      if (answer) {
        answer.hidden = true;
      }
      button.addEventListener('click', function () {
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        item.classList.toggle('is-open', !isOpen);
        if (answer) {
          answer.hidden = isOpen;
        }
      });
    });
  }

  function initPdpDetailsPullUp(root) {
    if (root !== document) return;
    var left = document.querySelector('.self-figma-pdp__left');
    var right = document.querySelector('.self-figma-pdp__details');
    var desc = document.querySelector('.self-product-content, .self-bra-description');
    if (!left || !right || !desc || desc.dataset.selfPullReady === 'true') return;
    desc.dataset.selfPullReady = 'true';

    var apply = function () {
      if (window.innerWidth < 990) {
        desc.style.removeProperty('margin-top');
        return;
      }
      var delta = left.getBoundingClientRect().bottom - right.getBoundingClientRect().bottom;
      var pull = Math.max(0, delta - 24);
      if (pull > 8) {
        desc.style.setProperty('margin-top', -pull + 'px', 'important');
        // keep the empty left spacer transparent so the taller left column's tail still shows through
        desc.style.setProperty('background', 'transparent', 'important');
        // clicks must pass through the transparent overlap to the left column's tail
        desc.classList.add('is-pulled-up');
      } else {
        desc.style.removeProperty('margin-top');
        desc.style.removeProperty('background');
        desc.classList.remove('is-pulled-up');
      }
    };
    apply();
    window.addEventListener('load', apply);
    window.addEventListener('resize', apply);
    [400, 1200, 2500, 4000].forEach(function (t) { setTimeout(apply, t); });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(apply);
      ro.observe(left);
      ro.observe(right);
    }
  }

  var mobileTitleFitListening = false;

  function fitPdpMobileTitles() {
    qsa('.self-figma-pdp__title[data-self-fit-mobile-title]', document).forEach(function (title) {
      title.style.removeProperty('--self-mobile-title-size');
      if (window.innerWidth > 749) return;
      var available = title.clientWidth;
      var naturalWidth = title.scrollWidth;
      var size = parseFloat(window.getComputedStyle(title).fontSize);
      if (available > 0 && naturalWidth > available && Number.isFinite(size)) {
        var next = Math.floor(size * (available - 1) / naturalWidth * 10) / 10;
        title.style.setProperty('--self-mobile-title-size', next + 'px');
      }
    });
  }

  function initPdpMobileTitleFit() {
    fitPdpMobileTitles();
    if (mobileTitleFitListening) return;
    mobileTitleFitListening = true;
    window.addEventListener('resize', fitPdpMobileTitles);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPdpMobileTitles);
  }

  function init(root) {
    initTabs(root);
    initWishlist(root);
    initCartBadge();
    initCartDrawerLink();
    initChatFab();
    initGeoCurrency();
    initFilters(root);
    initManualCollectionFilters(root);
    initExactBestsellers(root);
    initCardSwatches(root);
    initProductCardTouch(root);
    initQuickAdd(root);
    initProductGallery(root);
    initVariantForms(root);
    initFinder(root);
    initBackToTop(root);
    initCollectionSeoToggles(root);
    initPdpZoomCloseSafeguard(root);
    initPdpQuestionAccordions(root);
    initPdpMobileTitleFit(root);
    initPdpDetailsPullUp(root);
  }

  window.selfTheme = window.selfTheme || {};
  window.selfTheme.openQuickView = openQuickView;
  window.selfTheme.openQuickViewFromElement = openQuickViewFromElement;

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
